"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.updateMarkersState = exports.setSelectedMarkerIcon = exports.setHoverMarkerIcon = exports.setFocusMarkerIcon = exports.setEnabledMarkerIcon = exports.setDisabledMarkerIcon = exports.setCustomMarkerIcon = exports.setClickedMarkerIcon = exports.isEqualSets = exports.getMapContainerCorners = exports.clearMarkers = exports.addMarkers = void 0;
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _uiTheme = require("@kyruus/ui-theme");
var _markerConstants = require("./markerConstants");
const PIN_SVG_PATH = 'M91,41.1689008 C90.9298004,46.7414571 89.3970218,52.1926491 86.5577884,56.9842358 C83.7028796,61.9827614 80.5672126,66.8915135 77.2911663,71.6009243 C70.3021612,81.5198986 64.6390702,92.0169023 61.5539237,103.810426 C61.1249086,105.438845 60.883099,107.129747 60.4658354,108.808951 L60.4697293,108.808951 C60.2669284,109.250231 59.990014,109.652453 59.6507078,110 C59.2957961,109.671977 59.0071901,109.277553 58.8004853,108.840142 C55.6063103,94.0325078 48.6284876,81.0983229 39.7834024,68.9808972 C36.8388348,65.0640525 34.1711315,60.9480666 31.795968,56.6645301 C22.5488154,39.4316132 30.5362498,16.0864993 52.0531001,10.8890323 C71.7800662,6.12873648 90.9918428,21.0970213 91,41.1691007 L91,41.1689008 Z';
const MARKER_SCALE = 0.5;
const getUnselectedMarkerIcon = (gMaps, theme) => ({
  anchor: new gMaps.Point(40, 110),
  labelOrigin: new gMaps.Point(60, 42),
  path: PIN_SVG_PATH,
  fillOpacity: 1,
  fillColor: (0, _uiTheme.fromTheme)('color_providermatch')({
    theme
  }),
  strokeColor: 'white',
  strokeWeight: 2,
  scale: MARKER_SCALE
});
const getSelectedMarkerIcon = function (gMaps, theme) {
  let pinSvgPath = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : PIN_SVG_PATH;
  return {
    anchor: new gMaps.Point(40, 110),
    labelOrigin: new gMaps.Point(60, 42),
    path: pinSvgPath,
    fillOpacity: 1,
    fillColor: 'white',
    strokeColor: (0, _uiTheme.fromTheme)('color_providermatch')({
      theme
    }),
    strokeWeight: 2,
    scale: MARKER_SCALE * 1.5
  };
};

/**
 * @param {google.maps.Marker} marker
 * @param {google.maps} gMaps
 */
const setEnabledMarkerIcon = (marker, gMaps, theme, defaultMarkerIcon) => {
  marker.setIcon(getUnselectedMarkerIcon(gMaps, theme, defaultMarkerIcon));
};

/**
 * @param {google.maps.Marker} marker
 * @param {google.maps} gMaps
 */
exports.setEnabledMarkerIcon = setEnabledMarkerIcon;
const setDisabledMarkerIcon = (marker, gMaps, theme) => {
  marker.setIcon({
    ...getUnselectedMarkerIcon(gMaps, theme),
    fillOpacity: 0.5
  });
};

/**
 * @param {google.maps.Marker} marker
 * @param {google.maps} gMaps
 */
exports.setDisabledMarkerIcon = setDisabledMarkerIcon;
const setSelectedMarkerIcon = (marker, gMaps, theme) => {
  marker.setIcon(getSelectedMarkerIcon(gMaps, theme));
};

/**
 * Sets a custom icon for a marker.
 *
 * @param {google.maps.Marker} marker - Google marker instance
 * @param {string} customIcon - Base64 encoded image string
 */
exports.setSelectedMarkerIcon = setSelectedMarkerIcon;
const setCustomMarkerIcon = (marker, customIcon) => {
  marker.setIcon({
    url: customIcon,
    scale: MARKER_SCALE * 1.5
  });
};

/**
 * Sets hover marker icon for hover state
 *
 * @param {google.maps.Marker} marker - Google marker instance
 */
exports.setCustomMarkerIcon = setCustomMarkerIcon;
const setHoverMarkerIcon = marker => {
  const iconConfig = {
    url: _markerConstants.MARKER_SVGS.HOVER
  };
  marker.setIcon(iconConfig);
  marker.setZIndex(_markerConstants.ZINDEXES.HOVER);
};

/**
 * Sets focus marker icon for focus state (mousedown/keyboard focus)
 *
 * @param {google.maps.Marker} marker - Google marker instance
 */
exports.setHoverMarkerIcon = setHoverMarkerIcon;
const setFocusMarkerIcon = marker => {
  const iconConfig = {
    url: _markerConstants.MARKER_SVGS.FOCUS
  };
  marker.setIcon(iconConfig);
  marker.setZIndex(_markerConstants.ZINDEXES.FOCUS);
};

/**
 * Sets clicked marker icon for clicked state (persistent after click)
 *
 * @param {google.maps.Marker} marker - Google marker instance
 */
exports.setFocusMarkerIcon = setFocusMarkerIcon;
const setClickedMarkerIcon = marker => {
  const iconConfig = {
    url: _markerConstants.MARKER_SVGS.CLICKED
  };
  marker.setIcon(iconConfig);
  marker.setZIndex(_markerConstants.ZINDEXES.CLICKED);
};
exports.setClickedMarkerIcon = setClickedMarkerIcon;
const updateMarkersState = _ref => {
  let {
    markers,
    enabledLocationIds,
    selectedLocation,
    gMaps,
    theme,
    defaultMarkerIcon,
    hoveredMarkerId,
    focusedMarkerId,
    keyboardFocusedMarkerId,
    clickedMarkerId
  } = _ref;
  (0, _forEach.default)(markers).call(markers, _ref2 => {
    let {
      marker,
      meta
    } = _ref2;
    const isSelected = meta.location.id === selectedLocation?.id;
    const isDisabled = !enabledLocationIds.has(meta.location.id);
    const isHovered = meta.location.id === hoveredMarkerId;
    const isFocused = meta.location.id === focusedMarkerId;
    const isKeyboardFocused = meta.location.id === keyboardFocusedMarkerId;
    const isClicked = meta.location.id === clickedMarkerId;
    meta.isSelected = isSelected;
    meta.isDisabled = isDisabled;

    // Priority: Clicked > Keyboard Focus > Mouse Focus > Selected > Disabled > Hovered > Default
    if (isClicked) {
      return setClickedMarkerIcon(marker);
    }
    if (isKeyboardFocused) {
      return setFocusMarkerIcon(marker);
    }
    if (isFocused) {
      return setFocusMarkerIcon(marker);
    }
    if (isSelected) {
      return setSelectedMarkerIcon(marker, gMaps, theme);
    }
    if (isDisabled) {
      return setDisabledMarkerIcon(marker, gMaps, theme);
    }
    if (isHovered) {
      return setHoverMarkerIcon(marker);
    }
    if (defaultMarkerIcon) {
      return setCustomMarkerIcon(marker, defaultMarkerIcon);
    }
    return setEnabledMarkerIcon(marker, gMaps, theme);
  });
};

/**
 * Adds markers to google map.
 *
 * NOTE: map will adjust its bounds based on all markers **before** all their animations have run
 * @param {Object} props
 * @param {google.maps} props.gMaps
 * @param {google.maps.bounds} props.bound
 * @param {google.maps.map} props.map
 * @param {Array} props.locations
 * @param {Boolean} props.shouldLabelMarkers
 * @param {Object} props.theme
 */
exports.updateMarkersState = updateMarkersState;
const addMarkers = _ref3 => {
  let {
    gMaps,
    oms,
    bounds,
    map,
    locations,
    shouldLabelMarkers,
    theme,
    defaultMarkerIcon
  } = _ref3;
  const markers = (0, _map.default)(locations).call(locations, (location, index) => {
    const {
      lat,
      lon: lng
    } = location.coordinates;
    const position = {
      lat,
      lng
    };
    const marker = new gMaps.Marker({
      map,
      position,
      title: location.name,
      label: shouldLabelMarkers ? {
        text: `${index + 1}`,
        color: 'white'
      } : null
    });
    setEnabledMarkerIcon(marker, gMaps, theme);
    if (defaultMarkerIcon) {
      setCustomMarkerIcon(marker, defaultMarkerIcon);
    }

    // Add marker via OverlappingMarkerSpiderfier if it exists
    if (typeof oms === 'object' && typeof oms.addMarker === 'function') {
      oms.addMarker(marker);
    }
    bounds.extend(position);
    // Exposing `marker animation` here
    // because it's faster to do `meta.startAnimation` then to go
    // through the react render loop by altering props
    return {
      marker,
      meta: {
        startAnimation: () => marker.setAnimation(gMaps.Animation.BOUNCE),
        stopAnimation: () => marker.setAnimation(null),
        location,
        isDisabled: false,
        isSelected: false,
        eventListeners: []
      }
    };
  });
  map.fitBounds(bounds);
  return markers;
};

/**
 * @param {Array<{marker: google.maps.marker, meta: Object}>} markers
 */
exports.addMarkers = addMarkers;
const clearMarkers = markers => {
  (0, _forEach.default)(markers).call(markers, _ref4 => {
    var _context;
    let {
      marker,
      meta
    } = _ref4;
    (0, _forEach.default)(_context = meta.eventListeners).call(_context, listener => listener.remove());
    marker.setMap(null);
  });
};
exports.clearMarkers = clearMarkers;
const isEqualSets = (as, bs) => {
  if (as.size !== bs.size) return false;
  for (let a of as) if (!bs.has(a)) return false;
  return true;
};

/**
 * Gets the corners of the map container.
 *
 * @param {*} mapRef
 * @returns
 */
exports.isEqualSets = isEqualSets;
const getMapContainerCorners = mapRef => {
  const bounds = mapRef.getBounds();
  if (bounds) {
    const ne = bounds.getNorthEast();
    const sw = bounds.getSouthWest();
    return {
      topLeft: {
        lat: ne.lat(),
        lng: sw.lng()
      },
      bottomRight: {
        lat: sw.lat(),
        lng: ne.lng()
      }
    };
  }
  return {};
};
exports.getMapContainerCorners = getMapContainerCorners;